import axiosInstance from "../../axios/axios";
import { formatDate } from "../../helper/formatDate";



export function getHorseCategories() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/Lookup/GetHorseCategories`).then(response => {
            if (response.status == 200) {
                if (response.data?.responseCode == "200") {
                    const res = response?.data?.result;
                    const list = response?.data?.result?.map((item) => ({
                        label: item?.nameEn ?? '',
                        text: item?.nameEn ?? '',
                        value: item?.id,
                        ...item
                    }))
                    resolve(list ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject(false))
    })
}

export function getSpecialPrizesByShowId(showId) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/shows/getspecialprizebyshowid?id=${showId}`).then(response => {
            if (response.status == 200) {
                if (response.data?.responseCode == "200") {
                    const list = response?.data?.result;
                    resolve(list ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject(false))
    })
}
export function getChampionResultById(championId, HorseChampionId = "") {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/shows/getchampionshipwithjudgesinsideresult?ChapiomshipId=${championId}&ChapiomshipHorseId=${HorseChampionId}`).then(response => {
            if (response.status == 200) {
                if (response.data?.responseCode == "200") {
                    const obj = response?.data?.result;
                    resolve(obj ?? {})
                }
            }
            resolve({});
        }).catch(error => reject(false))
    })
}

export function geteligiblestallions(ownerId, collectionDate, serviceDefinitionId) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/requestsemencertificate/geteligiblestallions`, {
            ownerId: ownerId,
            searchDate: collectionDate,
            serviceDefinitionId: serviceDefinitionId
        }).then(response => {
            if (response.status == 200) {
                if (response.data?.status?.responseCode == "200") {
                    const list = response?.data?.result?.map((item) => ({
                        label: item?.name ?? '',
                        text: item?.name ?? '',
                        value: item?.id,
                        ...item
                    }))
                    resolve(list ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject(false))
    })
}
export function checkPenalty(serviceId, CoveringId, birthDate) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/RegisteringNewArabianHorseFoalServiceRequest/HasRegistrationPenalty`, {
            Id: serviceId,
            CoveringId: CoveringId,
            BirthDate: formatDate(birthDate),
        }).then(response => {
            if (response.status == 200) {
                const res = response?.data?.result ?? false;
                resolve(res)
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}

export function getCountries() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/lookup/getcountries`).then(response => {
            if (response.status == 200) {
                const res = response.data.map((item) => ({
                    label: item?.text,
                    ...item
                }))
                resolve(res ?? [])
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}

export function getCitiesListbyID(id) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/lookup/getcitybycountryid?id=${id}`).then(response => {
            if (response.status == 200) {
                const res = response.data.result.map((item) => ({
                    label: item?.name,
                    text: item?.name,
                    value: item?.id,
                    ...item
                }))
                resolve(res ?? [])
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}

export function getRegionListbyID(id) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/lookup/getareasbyemirateid?EmirateId=${id}`).then(response => {
            if (response.status == 200) {
                const res = response.data.result.map((item) => ({
                    label: item?.name,
                    text: item?.name,
                    value: item?.id,
                    ...item
                }))
                resolve(res ?? [])
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}


export function getHorseColors() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/lookup/gethorsecolors`).then(response => {
            if (response.status == 200) {
                if (response.data.responseCode == "200") {
                    const res = response.data?.result.map((item) => ({
                        label: item?.nameEn,
                        text: item?.nameEn,
                        value: item?.id,
                        ...item
                    }))
                    resolve(res ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}
export function getHorseEraRaceingResults(horseId) {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/erarace/geteraraceresultsbyhorseid/${horseId}`).then(response => {
            if (response.status == 200) {
                if (response?.data.responseCode == "200") {
                    const res = response.data?.result ?? [];
                    resolve(res ?? [])
                }
            }
            resolve([]);
        }).catch(error => reject([]))
    })
}


